import {
  CreateDeploymentRequestComponentNameRequest,
  CreateDeploymentRequestComponentNameResponse,
  CreateDeploymentRequestDataKindNamesRequest,
  CreateDeploymentRequestDataKindNamesResponse,
  CreateInterfaceDeploymentRequestRequest,
  CreateInterfaceDeploymentRequestResponse,
  GetDeploymentRequestRequest,
  GetDeploymentRequestResponse,
  UpdateInterfaceDeploymentRequestRequest,
  UpdateInterfaceDeploymentRequestResponse,
  UpdateInterfaceDeploymentRequestStatusRequest,
  UpdateInterfaceDeploymentRequestStatusResponse,
  CreateDeploymentRequestInterfacePartnerNamesRequest,
  CreateDeploymentRequestInterfacePartnerNamesResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface DeploymentRequestRestResource {
  createDeploymentRequestDataKindNames(
    request: CreateDeploymentRequestDataKindNamesRequest,
  ): Promise<CreateDeploymentRequestDataKindNamesResponse>;
  createInterfaceDeploymentRequest(
    request: CreateInterfaceDeploymentRequestRequest,
  ): Promise<CreateInterfaceDeploymentRequestResponse>;
  updateInterfaceDeploymentRequest(
    request: UpdateInterfaceDeploymentRequestRequest,
  ): Promise<UpdateInterfaceDeploymentRequestResponse>;
  getDeploymentRequest(
    request: GetDeploymentRequestRequest,
  ): Promise<GetDeploymentRequestResponse>;
  createDeployPartnerNames(
    request: CreateDeploymentRequestInterfacePartnerNamesRequest,
  ): Promise<CreateDeploymentRequestInterfacePartnerNamesResponse>;
  updateInterfaceDeploymentRequestStatus(
    request: UpdateInterfaceDeploymentRequestStatusRequest,
  ): Promise<UpdateInterfaceDeploymentRequestStatusResponse>;
  createDeploymentRequestComponentName(
    request: CreateDeploymentRequestComponentNameRequest,
  ): Promise<CreateDeploymentRequestComponentNameResponse>;
}

const REST_RESOURCE_NAME = "/deployment-request";
/**
 * PUT /deployment-request/data-kind-names
 */
const createDeploymentRequestDataKindNames = restResourceRequester<
  CreateDeploymentRequestDataKindNamesRequest,
  CreateDeploymentRequestDataKindNamesResponse
>(
  "PUT",
  (_) => {
    return `${REST_RESOURCE_NAME}/data-kind-names`;
  },
  (request) => JSON.stringify(request),
);

/**
 * PUT /deployment-request/component-name
 */
const createDeploymentRequestComponentName = restResourceRequester<
  CreateDeploymentRequestComponentNameRequest,
  CreateDeploymentRequestComponentNameResponse
>(
  "PUT",
  (_) => {
    return `${REST_RESOURCE_NAME}/component-name`;
  },
  (request) => JSON.stringify(request),
);

const createInterfaceDeploymentRequest = restResourceRequester<
  CreateInterfaceDeploymentRequestRequest,
  CreateInterfaceDeploymentRequestResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME}/interface`,
  (request) => JSON.stringify(request),
);

const updateInterfaceDeploymentRequest = restResourceRequester<
  UpdateInterfaceDeploymentRequestRequest,
  UpdateInterfaceDeploymentRequestResponse
>(
  "PUT",
  (request) => `${REST_RESOURCE_NAME}/interface/${request.dplymntReqSeq}`,
  (request) => JSON.stringify(request),
);

/**
 * GET /deployment-requests
 */
const getDeploymentRequest = restResourceRequester<
  GetDeploymentRequestRequest,
  GetDeploymentRequestResponse
>("GET", (request) => `${REST_RESOURCE_NAME}/${request.dplymntReqSeq}`);

/**
 * PUT /deployment-request/partner-names
 */
const createDeployPartnerNames = restResourceRequester<
  CreateDeploymentRequestInterfacePartnerNamesRequest,
  CreateDeploymentRequestInterfacePartnerNamesResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME}/partner-names`,
  (request) => JSON.stringify(request),
);

const updateInterfaceDeploymentRequestStatus = restResourceRequester<
  UpdateInterfaceDeploymentRequestStatusRequest,
  UpdateInterfaceDeploymentRequestStatusResponse
>(
  "PUT",
  (request) =>
    `${REST_RESOURCE_NAME}/interface/${request.dplymntReqSeq}/status`,
  (request) => JSON.stringify(request),
);

export const DeploymentRequestRestResource: DeploymentRequestRestResource = {
  createDeploymentRequestDataKindNames: createDeploymentRequestDataKindNames,
  createInterfaceDeploymentRequest: createInterfaceDeploymentRequest,
  updateInterfaceDeploymentRequest: updateInterfaceDeploymentRequest,
  getDeploymentRequest: getDeploymentRequest,
  createDeployPartnerNames: createDeployPartnerNames,
  updateInterfaceDeploymentRequestStatus:
    updateInterfaceDeploymentRequestStatus,
  createDeploymentRequestComponentName: createDeploymentRequestComponentName,
};
